import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/faqEvent.js";
import useSiteContent from "../hooks/useSiteContent";

function FaqEvent() {
  const faq = useSiteContent("faq");
  const faqs = (faq.categories || []).flatMap((c) => c.items || []);

  // Bind accordion toggles once the FAQ items have rendered
  useEffect(() => {
    const accordionButton = document.querySelectorAll(".accordion-button");
    accordionButton.forEach((button) => {
      button.addEventListener("click", () => {
        button.classList.toggle("active");
        const content = button.nextElementSibling;

        if (button.classList.contains("active")) {
          content.className = "accordion-content show";
          content.style.maxHeight = content.scrollHeight + "px";
        } else {
          content.className = "accordion-content";
          content.style.maxHeight = "0";
        }
      });
    });
  }, [faqs.length]);

  // Split FAQ data into left and right halves
  const mid = Math.ceil(faqs.length / 2);
  const leftData = faqs.slice(0, mid);
  const rightData = faqs.slice(mid);

  return (
    <Styles>
      <section className="event-faq-area">
        <Container>
          {/* Section Title */}
          <Row>
            <Col md="12">
              <div className="sec-title">
                <h4>
                  {faq.homeTitle} <span>{faq.homeTitleHighlight}</span>
                </h4>
              </div>
            </Col>
          </Row>

          <Row>
            {/* Left Column */}
            <Col md="6">
              <div className="faq-area">
                <div className="faq-box">
                  {leftData.map((item, i) => (
                    <div className="faq-item" key={i}>
                      <button className="accordion-button active">
                        <div className="accordion-icon">
                          <i className="las la-plus"></i>
                        </div>
                        <p>{item.question}</p>
                      </button>
                      <div className="accordion-content show">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>

            {/* Right Column */}
            <Col md="6">
              <div className="faq-area">
                <div className="faq-box">
                  {rightData.map((item, i) => (
                    <div className="faq-item" key={i}>
                      <button className="accordion-button active">
                        <div className="accordion-icon">
                          <i className="las la-plus"></i>
                        </div>
                        <p>{item.question}</p>
                      </button>
                      <div className="accordion-content show">
                        <p>{item.answer}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Styles>
  );
}

export default FaqEvent;
